import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-audio-input-test',
  templateUrl: './audio-input-test.component.html',
  styleUrls: ['./audio-input-test.component.scss']
})
export class AudioInputTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
